import React from 'react';

interface ProgressBarProps {
  progress: number;
  bgClassName?: string;
  className?: string;
}

function ProgressBar({ progress, bgClassName, className }: ProgressBarProps) {
  return (
    <div className="w-full bg-gray-200 rounded-full h-2.5 mb-4 dark:bg-gray-700">
      <div
        className="bg-purple-400 h-2.5 rounded-full"
        style={{ width: `${progress}%` }}
      />
    </div>
  );
}

export default ProgressBar;
